import React from "react";
import { Box } from "@mui/material";
import MessagingApiConfigDataTable from "../components/messaging-api-config/MessagingApiConfigDataTable";
import apiConfig from "../config/appConfig";

const MessagingApiConfigs = () => {
  const apiUrl = apiConfig.endpoints.messagingApiConfig.paginated; // Replace with your backend API endpoint

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <MessagingApiConfigDataTable apiUrl={apiUrl} />
    </Box>
  );
};

export default MessagingApiConfigs;
